// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dynamicLobby__liveTile{--liveTileWidth:168px;display:flex;flex-shrink:0;width:var(--liveTileWidth)}.dynamicLobby__liveTile+.dynamicLobby__liveTile{margin-left:8px}.dynamicLobby__liveTile--large{--liveTileWidth:264px}@media (min-width:1025px){.dynamicLobby__liveTile{--liveTileWidth:202px}.dynamicLobby__liveTile--large{--liveTileWidth:316px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
